import type { RouteObject } from "react-router";
import { DispatchReport } from "./DispatchReport";

/** The dispatch-report route, relative to /report. */
export const dispatchReportRoute: RouteObject = {
  path: "dispatch-report",
  element: <DispatchReport />,
};
